import { sendJsonMutation } from '../../components/write-request.js';
import { isRecord, parseJsonSafely } from './helpers.js';

export async function searchGhostCovers({ url, query, limit }) {
    try {
        const params = new URLSearchParams({
            q: query,
            limit: String(limit),
        });

        const response = await fetch(`${url}?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            credentials: 'same-origin',
        });
        const payload = await parseJsonSafely(response);

        if (response.ok && isRecord(payload) && payload.success === true && Array.isArray(payload.results)) {
            return {
                ok: true,
                payload,
                errorMessage: '',
            };
        }

        return {
            ok: false,
            payload,
            errorMessage: 'Search failed. Try again.',
        };
    } catch (error) {
        return {
            ok: false,
            payload: null,
            errorMessage: 'Search failed. Check connection and try again.',
        };
    }
}

export async function addGhostCover({ url, csrfToken, igdbSourceKey }) {
    return sendJsonMutation(fetch, {
        url,
        csrfToken,
        fallbackErrorMessage: 'Failed to add ghost cover.',
        body: {
            igdb_source_key: igdbSourceKey,
        },
    });
}

export async function removeGhostCover({ url, csrfToken }) {
    return sendJsonMutation(fetch, {
        url,
        csrfToken,
        fallbackErrorMessage: 'Failed to remove cover.',
        body: {},
    });
}

export async function reorderGhostCovers({ url, csrfToken, orderedIds }) {
    return sendJsonMutation(fetch, {
        url,
        csrfToken,
        fallbackErrorMessage: 'Failed to save cover order.',
        body: {
            ordered_ids: orderedIds,
        },
    });
}
